import {
  WIZARD_CREATE_GWS_ADMIN,
  WIZARD_CREATE_TENANT,
  WIZARD_ENABLE_DMARC,
  WIZARD_ENABLE_GWS,
  WIZARD_FETCH_FAILED_MAILBOXES,
  WIZARD_FETCH_GROUPS,
  WIZARD_FETCH_STATUS,
  WIZARD_GET_SETTINGS_OPTIONS,
  WIZARD_RESET,
  WIZARD_RESUME_SESSION,
  WIZARD_SAVE_SETTINGS,
  WIZARD_SET_PROVIDER,
  WIZARD_SET_STEP,
  WIZARD_TRIGGER_SYNC,
} from './constants'

const initialState = {
  currentStep: 1,

  companyId: null,
  adminPassword: null,
  provider: null,

  createLoader: false,
  createError: null,

  statusLoader: false,
  statusData: null,
  syncLoader: false,
  syncError: null,

  settingsOptionsLoader: false,
  settingsOptions: null,

  settingsLoader: false,
  settingsError: null,

  dmarcLoader: false,
  dmarcError: null,

  groupsLoader: false,
  groups: null,
  groupsError: null,

  failedMailboxesLoader: false,
  failedMailboxes: null,

  gwsAdminLoader: false,
  gwsAdminError: null,

  gwsEnableLoader: false,
  gwsEnableError: null,
}

export default function onboardingWizardReducer(state = initialState, action = {}) {
  switch (action.type) {
    case WIZARD_SET_STEP:
      return { ...state, currentStep: action.payload.step, createError: null }

    case WIZARD_SET_PROVIDER:
      return { ...state, provider: action.payload.provider }

    case WIZARD_CREATE_TENANT.INITIATE:
      return {
        ...state,
        createLoader: true,
        createError: null,
        provider: action.payload?.provider || state.provider,
      }
    case WIZARD_CREATE_TENANT.SUCCESS: {
      const { company_id: companyId, admin_password: adminPassword } = action.payload
      return {
        ...state,
        createLoader: false,
        companyId,
        adminPassword,
        currentStep: 3,
      }
    }
    case WIZARD_CREATE_TENANT.ERROR:
      return { ...state, createLoader: false, createError: action.error }

    case WIZARD_FETCH_STATUS.INITIATE:
      return { ...state, statusLoader: true }
    case WIZARD_FETCH_STATUS.SUCCESS:
      return { ...state, statusLoader: false, statusData: action.payload }
    case WIZARD_FETCH_STATUS.ERROR:
      return { ...state, statusLoader: false }

    case WIZARD_TRIGGER_SYNC.INITIATE:
      return { ...state, syncLoader: true, syncError: null }
    case WIZARD_TRIGGER_SYNC.SUCCESS:
      return {
        ...state,
        syncLoader: false,
        statusData: state.statusData
          ? {
              ...state.statusData,
              sync: { ...state.statusData.sync, status: 'in_progress' },
            }
          : state.statusData,
      }
    case WIZARD_TRIGGER_SYNC.ERROR:
      return { ...state, syncLoader: false, syncError: action.error }

    case WIZARD_GET_SETTINGS_OPTIONS.INITIATE:
      return { ...state, settingsOptionsLoader: true }
    case WIZARD_GET_SETTINGS_OPTIONS.SUCCESS:
      return { ...state, settingsOptionsLoader: false, settingsOptions: action.payload }
    case WIZARD_GET_SETTINGS_OPTIONS.ERROR:
      return { ...state, settingsOptionsLoader: false }

    case WIZARD_SAVE_SETTINGS.INITIATE:
      return { ...state, settingsLoader: true, settingsError: null }
    case WIZARD_SAVE_SETTINGS.SUCCESS:
      return { ...state, settingsLoader: false, currentStep: 6 }
    case WIZARD_SAVE_SETTINGS.ERROR:
      return { ...state, settingsLoader: false, settingsError: action.error }

    case WIZARD_ENABLE_DMARC.INITIATE:
      return { ...state, dmarcLoader: true, dmarcError: null }
    case WIZARD_ENABLE_DMARC.SUCCESS:
      return { ...state, dmarcLoader: false }
    case WIZARD_ENABLE_DMARC.ERROR:
      return { ...state, dmarcLoader: false, dmarcError: action.error }

    case WIZARD_FETCH_GROUPS.INITIATE:
      return { ...state, groupsLoader: true, groupsError: null }
    case WIZARD_FETCH_GROUPS.SUCCESS: {
      const groupsList =
        action.payload?.groups || (Array.isArray(action.payload) ? action.payload : [])
      return { ...state, groupsLoader: false, groups: groupsList, groupsError: null }
    }
    case WIZARD_FETCH_GROUPS.ERROR:
      return { ...state, groupsLoader: false, groupsError: action.error }

    case WIZARD_FETCH_FAILED_MAILBOXES.INITIATE:
      return { ...state, failedMailboxesLoader: true }
    case WIZARD_FETCH_FAILED_MAILBOXES.SUCCESS: {
      const list =
        action.payload?.failed_mailboxes ||
        action.payload?.response?.failed_mailboxes ||
        (Array.isArray(action.payload) ? action.payload : [])
      return { ...state, failedMailboxesLoader: false, failedMailboxes: list }
    }
    case WIZARD_FETCH_FAILED_MAILBOXES.ERROR:
      return { ...state, failedMailboxesLoader: false }

    case WIZARD_CREATE_GWS_ADMIN.INITIATE:
      return { ...state, gwsAdminLoader: true, gwsAdminError: null }
    case WIZARD_CREATE_GWS_ADMIN.SUCCESS:
      return { ...state, gwsAdminLoader: false }
    case WIZARD_CREATE_GWS_ADMIN.ERROR:
      return { ...state, gwsAdminLoader: false, gwsAdminError: action.error }

    case WIZARD_ENABLE_GWS.INITIATE:
      return { ...state, gwsEnableLoader: true, gwsEnableError: null }
    case WIZARD_ENABLE_GWS.SUCCESS:
      return { ...state, gwsEnableLoader: false }
    case WIZARD_ENABLE_GWS.ERROR:
      return { ...state, gwsEnableLoader: false, gwsEnableError: action.error }

    case WIZARD_RESUME_SESSION: {
      const resumedStep =
        action.payload?.step == null ? state.currentStep : Math.max(3, action.payload.step)
      return {
        ...state,
        companyId: action.payload?.companyId ?? state.companyId,
        provider: action.payload?.provider || state.provider,
        currentStep: resumedStep,
        createError: null,
      }
    }

    case WIZARD_RESET:
      return { ...initialState }

    default:
      return state
  }
}
